// extracted by mini-css-extract-plugin
export default {"ctaPrice":"ProductActions-ctaPrice-6uE","cta":"ProductActions-cta-3E-","qtyInput":"ProductActions-qtyInput-vEN","addToCart":"ProductActions-addToCart-MxS"};